import type {
	Components,
} from '@mui/material'

export const materialUIAppBarTheme: {
	components: Components
} = {
	components: {
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: 'var(--surface-container-color)',
					padding:         'var(--base-spacing-2) var(--base-spacing-2)',
					borderBottom:    'var(--outline-base)',
				},
			},
		},
	},
}
